"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * When using a cursor container, the tooltip can be offset from the cursor point. If true, the tooltip
 * will appear to the right of the vertical cursor.
 *
 * @param {boolean} offsetCursorDimensionX If true, the tooltip will appear to the right of the vertical cursor
 * @param {boolean} offsetCursorDimensionY If true, the tooltip will appear above the horizontal cursor
 */
exports.getTooltipCenterOffset = (offsetCursorDimensionX = false, offsetCursorDimensionY = false) => {
    const offsetX = (props) => props.flyoutWidth / 2 + 5;
    const offsetY = (props) => -(props.flyoutHeight / 2 + 5);
    return {
        x: offsetCursorDimensionX ? offsetX : 0,
        y: offsetCursorDimensionY ? offsetY : 0
    };
};
//# sourceMappingURL=chart-tooltip.js.map